import { render, staticRenderFns } from "./BusDispatching.vue?vue&type=template&id=fee64d82&"
import script from "./BusDispatching.vue?vue&type=script&lang=js&"
export * from "./BusDispatching.vue?vue&type=script&lang=js&"
import style0 from "./BusDispatching.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports